module.exports = __webpack_public_path__ + "static/media/PlansConsumption.98211954.svg";